import "./vendor";
// import { vhFix } from "./vendor/vh-fix";
import { toggle } from "./components/toggle";
import { accordion } from "./components/accordion";
import { mobileMenu } from "./components/mobile-menu";
import { slider } from "./components/slider";
import { sliderThumbs } from "./components/sliderThumbs";
import { sliderJobs } from "./components/sliderJobs";
import { sliderAnywhere } from "./components/sliderAnywhere";
import { sliderGallery } from "./components/sliderGallery";
import { sliderFacilities } from "./components/sliderFacilities";
import { sliderPurpose } from "./components/sliderPurpose";
import { valuesSlider } from "./components/values-slider";
import { tabs } from "./components/tabs";
import { videoVimeo } from "./components/video-vimeo";
// import { sectionOverlap } from "./components/sectionOverlap";
import { scrollspy } from "./components/scrollspy";
import "./components/scrollto";

window.addEventListener(
  "load",
  () => {
    toggle.init();
    accordion.init();
    mobileMenu.init();
    slider.init();
    sliderJobs.init();
    sliderAnywhere.init();
    sliderThumbs.init();
    sliderGallery.init();
    sliderFacilities.init();
    sliderPurpose.init();
    valuesSlider.init();
    tabs.init();
    videoVimeo.init();
    scrollspy.init();
    // sectionOverlap.init();
    scrollspy.init();
    document.querySelector("body").classList.add("page-loaded");
  },
  false
);
